:host{display:block}
/*# sourceMappingURL=active-eoc.component-7HHTBPXV.css.map */
